import { render, staticRenderFns } from "./my_slide1.vue?vue&type=template&id=0b244c71&scoped=true&"
import script from "./my_slide1.vue?vue&type=script&lang=js&"
export * from "./my_slide1.vue?vue&type=script&lang=js&"
import style0 from "./my_slide1.vue?vue&type=style&index=0&id=0b244c71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b244c71",
  null
  
)

export default component.exports